import script from "./PointsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsList.vue?vue&type=script&setup=true&lang=js"

import "./PointsList.vue?vue&type=style&index=0&id=911b58e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-911b58e4"]])

export default __exports__